define('account-settings',['controller', 'dialogs', 'button-disabler'], function(controller, dialogs, buttonDisabler) {

    function openMailDialog(button) {
        var dialog = dialogs.openURL('/account/change_email');
        dialog.addClass('account-settings-dialog');

        buttonDisabler.disableUntilDone(button, dialog.opened);
    }

    function openPasswordDialog(button) {
        var dialog = dialogs.openURL('/account/change_password');
        dialog.addClass('account-settings-dialog');

        buttonDisabler.disableUntilDone(button, dialog.opened);

        dialog.on('submitFormResponse', function(e, status, data) {
            if (status == 200) {
                window.location.href = data.url;
            }
        });
    }

    function openUsernameDialog(button) {
        var dialog = dialogs.openURL('/account/change_username');
        dialog.addClass('account-settings-dialog');

        buttonDisabler.disableUntilDone(button, dialog.opened);

        dialog.on('submitFormResponse', function(e, status, data) {
            if (status == 200) {
                window.location.href = data.url;
            }
        });
    }

	controller.on('account/index', function() {
		function toggleGroupByLink($a) {
			$a.toggleClass('active');
			$a.next(".settings-window").slideToggle();
			
			// only allow one open window
			if ($a.hasClass('active')) {
				$(".toggle-button.active").each(function() {
					if (this != $a[0]) {
						$(this).removeClass("active");
						$(this).next(".settings-window").slideToggle();
					}
				});
		    }
		}

		// open the linked group, e.g. #username opens the username group
		var validTargets = ['#email', '#username', '#password'];
		if (validTargets.indexOf(location.hash) !== -1) { // security critical!
			var $a = $('.settings-section a[href="' + location.hash + '"]');
			if ($a.length) {
				toggleGroupByLink($a);
			}
		}

        $('.change-email').click(function() {
            openMailDialog($(this));
        });

        $('.change-password').click(function() {
            openPasswordDialog($(this));
        });

        $('.change-user-name').click(function() {
            openUsernameDialog($(this));
        });
		
		// open groups on button click
		$(".settings-section .toggle-button").click(function(e) {
			if (e.which != 1)
				return; // only left button
			e.preventDefault();
			toggleGroupByLink($(this));
		});
	});
});

